var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h100 vh100 d-flex d-col"},[_c('TopToolbar'),_c('Login')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }